<mat-accordion multi="true" [togglePosition]="'before'" class="example-headers-align">
    <mat-expansion-panel class="threads-card" [expanded]="first">
        <mat-expansion-panel-header [ngClass]="{'read-thread-header': isRead(thread), 'not-read-thread-header': !isRead(thread)}" [expandedHeight]="'48px'">
            <mat-panel-title [ngSwitch]='expansionPanelTitle(thread)'>
                <div class="dont-wrap-subjects" *ngSwitchCase="'One Read Message'">
                    <mat-icon class="thread-message-icon">drafts</mat-icon>
                    <span class="thread-message-subject">{{ thread.subject | truncate: 24 }}</span>
                </div>
                <div class="dont-wrap-subjects" *ngSwitchCase="'One Unread Message'">
                    <mat-icon class="thread-message-icon">email</mat-icon>
                    <b class="thread-message-subject">{{ thread.subject | truncate: 24 }}</b>
                </div>
                <div class="dont-wrap-subjects-svg" *ngSwitchCase="'Multiple Unread Messages'">
                    <svg class="multiple-emails" width="25" height="25" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M2,6 L0,6 L0,11 L0.01,11 L0,20 C0,21.1 0.9,22 2,22 L20,22 L20,20 L2,20 L2,6 Z M22,2 L6,2 C4.9,2 4.01,2.9 4.01,4 L4,16 C4,17.1 4.9,18 6,18 L22,18 C23.1,18 24,17.1 24,16 L24,4 C24,2.9 23.1,2 22,2 Z M22,6 L14,11 L6,6 L6,4 L14,9 L22,4 L22,6 Z" id="path-1"></path>
                    </svg>
                    <b class="multi-pass-message-subject">{{ thread.subject | truncate: 24 }}</b>
                </div>
                <div class="dont-wrap-subjects-svg" *ngSwitchCase="'Multiple Read Messages'">
                    <svg class="multiple-emails" width="25" height="25" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M2,6 L0,6 L0,11 L0.01,11 L0,20 C0,21.1 0.9,22 2,22 L20,22 L20,20 L2,20 L2,6 Z M22,2 L6,2 C4.9,2 4.01,2.9 4.01,4 L4,16 C4,17.1 4.9,18 6,18 L22,18 C23.1,18 24,17.1 24,16 L24,4 C24,2.9 23.1,2 22,2 Z M22,6 L14,11 L6,6 L6,4 L14,9 L22,4 L22,6 Z" id="path-1"></path>
                    </svg>
                    <span class="multi-pass-message-subject">{{ thread.subject | truncate: 24 }}</span>
                </div>
            </mat-panel-title>
            <mat-panel-description [ngSwitch]='expansionPanelDescription(thread)'>
                <div *ngSwitchCase="'Multiple Emails'">
                    ({{ thread.messages.length }}) Conversation with {{ thread.messages[0]?.recipientRecords[0]?.name || thread.messages[0]?.recipientRecords[0]?.email }}
                    <span *ngIf="thread.messages[0].recipientCount === 2"> and 1 other</span>
                    <span *ngIf="thread.messages[0].recipientCount > 2"> and {{ thread.messages[0].recipientCount - 1 }} others</span>
                </div>
                <!-- No Recipent Records in the message data -->
                <div *ngSwitchCase="'Multiple Emails Missing Recipients'">
                    No recipient records on file to display
                </div>
                <!-- Marketing Email -->
                <div *ngSwitchCase="'Marketing Email'">Sent via Marketing
                    <span *ngIf="thread.messages[0].recipientCount === 2"> and 1 other</span>
                    <span *ngIf="thread.messages[0].recipientCount > 2"> and {{ thread.messages[0].recipientCount - 1 }} others</span>
                </div>
                <!-- Not Marketing, but still no recipients...Bulk email somehow??? -->
                <div *ngSwitchCase="'Missing Recipients'">Sent by: {{ thread.messages[0]?.fromEmail ?? 'Unknown Email' }}, but no recipeints recorded.
                    <span *ngIf="thread.messages[0].recipientCount === 2"> and 1 other</span>
                    <span *ngIf="thread.messages[0].recipientCount > 2"> and {{ thread.messages[0].recipientCount - 1 }} others</span>
                </div>
                <div *ngSwitchCase="'Single Non-Marketing Email'">Sent to: {{ thread.messages[0]?.recipientRecords[0]?.name ?? 'Unknown Email Recipient Name' }}
                    <span *ngIf="thread.messages[0].recipientCount === 2"> and 1 other</span>
                    <span *ngIf="thread.messages[0].recipientCount > 2"> and {{ thread.messages[0].recipientCount - 1 }} others</span>
                </div>
                <div *ngIf="thread && thread.attachmentCount">
                    <mat-icon>attachment</mat-icon>
                    <span class="thread-attachment-count">({{ thread.attachmentCount }})</span>
                </div>
                <div *ngIf="isRead(thread); else nonRead">
                    <div *ngIf="isToday(thread.messages[thread.messages?.length - 1]?.createdTimestamp)">{{ thread.messages[thread.messages?.length - 1]?.createdTimestamp * 1000 | date: 'shortTime' }}</div>
                    <div *ngIf="!isToday(thread.messages[thread.messages?.length - 1]?.createdTimestamp)">{{ thread.messages[thread.messages?.length - 1]?.createdTimestamp * 1000 | date: 'MMM d' }}</div>
                </div>
                <ng-template #nonRead>
                    <div *ngIf="isToday(thread.messages[thread.messages?.length - 1]?.createdTimestamp)"><b>{{ thread.messages[thread.messages?.length - 1]?.createdTimestamp * 1000 | date: 'shortTime' }}</b></div>
                    <div *ngIf="!isToday(thread.messages[thread.messages?.length - 1]?.createdTimestamp)"><b>{{ thread.messages[thread.messages?.length - 1]?.createdTimestamp * 1000 | date: 'MMM d' }}</b></div>
                </ng-template>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <app-message
            *ngFor="let message of thread.messages; trackBy: trackById; let messageIndex = index; let isFirst = first; let isLast = last; let messageCreateType = null;"
            [messageIndex]="messageIndex"
            [messageCreateType]="messageCreateType"
            [isFirst]="isFirst"
            [isLast]="isLast"
            [borrower]="borrower"
            [message]="message"
            [thread]="thread"
            [user]="user"
            [messageGroup]="(messageGroup$ | async)"
            (messageRead)="handleMessageRead($event)"
            (emailCreate)="handleEmailCreate($event)"
            (openMessageGroup)="openMessageGroup($event)"
        ></app-message>
    </mat-expansion-panel>
</mat-accordion>
